import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B478F822-6D6B-4A47-BCFE-0236D5766711
 * name view-day-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-day-outline.svg
 * tags
 * - View 
 */
export const ViewDayOutlineIcon = createSvgIcon(<><path d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" /></>, 'ViewDayOutlineIcon');
export default ViewDayOutlineIcon